import AnimatePrice from './product/animate-price';

document.addEventListener('DOMContentLoaded', () => {
    AnimatePrice.run({
        changeElem: '[data-price-options] input[data-price]',
        targetId: 'priceTargetId',
    });

    $('[data-review-form-add]').on('click', () => {
        $('.mc-newreview').trigger('click');
    });
});
